import { css } from "@emotion/react";
import { media } from "styles/breakpoints";

export const MarqueeStyle = {
  index: css`
    background: #000;
    min-width: 1480px;
    padding: 0 220px 0 190px;
    ${media.xxl} {
      width: 100%;
      min-width: unset;

      padding: 0 60px;
    }
  `,
  content: css`
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 4px 0;

    svg {
      color: white;
      width: 40px;
    }
  `,
  marquee: css`
    color: white;
    font-size: 16px;
    text-transform: uppercase;
    & .item {
      margin-right: 20px;
    }

    span {
      &:hover {
        text-decoration: underline;
      }
    }
  `,
};
